import styled from "styled-components/macro";

import { fontSize, fontStyle, colors } from "shared/styles/constants";

export const StyledLabel = styled.span`
  ${fontStyle.bold}
  ${fontSize.s};
  color: ${colors.white};
`;
